export default "__VITE_ASSET__d88b18f2__"